import { IEntityDto } from "./base";

export interface ICostType extends IEntityDto {
  description?: string;
  defaultMargin?: number;
  defaultArticleGroupId?: number;
  defaultArticleGroupDescription?: string;
  index?: number;
  costTypeGroup?: string;
  costTypeGroupTranslated?: string;
}
